module.exports = __webpack_public_path__ + "static/media/U1-T2-1-1b.e1b1d04a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-1-1b.svg
// module id = 510
// module chunks = 0